import React from "react";

const Frame1 = () => {
      return(
            <div className="about-parent">
                  <div className="about">About</div>
                  <div className="about">Pricing</div>
                  <div className="about">Review</div>
            </div>
      );
};

export default Frame1;